export default "__VITE_ASSET__BsS2SkOg__"